import { render, staticRenderFns } from "./TagAlertAssignRules.vue?vue&type=template&id=c3aba1a2&scoped=true&"
import script from "./TagAlertAssignRules.vue?vue&type=script&lang=ts&"
export * from "./TagAlertAssignRules.vue?vue&type=script&lang=ts&"
import style0 from "./TagAlertAssignRules.vue?vue&type=style&index=0&id=c3aba1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aba1a2",
  null
  
)

export default component.exports